// An OP quote whose item is already in the warehouse: Quote Ready books a
// warehouse drop-off and sends no email (spec docs/archive/202610/specs_20261019_op-quote-routing.md).
// The same rule as the Worker's `isWarehouseDropoffOp` (workers/src/services/quoteEmail.js),
// which decides what actually happens; keep the two in step.
export function isWarehouseDropoffOp(deal) {
    return deal?.channel === 'operator'
        && deal?.item_with_us === true
        && deal?.kind === 'trade_in';
}
